interface OverrideIndicatorProps {
  show: boolean;
  tooltip?: string;
  onReset?: () => void;
}

export default function OverrideIndicator({
  show,
  tooltip = "Manually overridden \u2014 click to reset",
  onReset,
}: OverrideIndicatorProps) {
  if (!show) return null;

  return (
    <span
      role="status"
      title={tooltip}
      onClick={(e) => {
        if (onReset) {
          e.stopPropagation();
          onReset();
        }
      }}
      className={`absolute top-0.5 left-0.5 w-1.5 h-1.5 rounded-full bg-honey-500 ${
        onReset ? "cursor-pointer hover:bg-honey-600 transition-colors" : ""
      }`}
    />
  );
}
